import { LTRText, STRText, RentalType } from './consts';

export const getTextFromRentalType = (rentalType) => {
    switch (rentalType) {
        case RentalType.LTR:
            return LTRText;
        case RentalType.STR:
            return STRText;
        default:
            return '';
    }
};
